/* Manforce x Upakarma landing page — shared behaviours (singleton) */
if (!window.__mfuLp) {
  window.__mfuLp = 1;
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function reveal() {
      var els = document.querySelectorAll('.mfu .rise:not(.in)');
      if (!('IntersectionObserver' in window) || reduce) {
        els.forEach(function (e) { e.classList.add('in'); });
        return;
      }
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      els.forEach(function (e) { io.observe(e); });
    }

    function setFinal(n) {
      var d = parseInt(n.getAttribute('data-dec') || '0', 10);
      n.textContent = parseFloat(n.getAttribute('data-count')).toFixed(d);
    }
    function animate(n) {
      var target = parseFloat(n.getAttribute('data-count')),
          dec = parseInt(n.getAttribute('data-dec') || '0', 10),
          dur = 1400, t0 = null;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        n.textContent = (target * e).toFixed(dec);
        if (p < 1) requestAnimationFrame(step); else n.textContent = target.toFixed(dec);
      }
      requestAnimationFrame(step);
    }
    function counters() {
      var nums = document.querySelectorAll('.mfu [data-count]');
      if (!('IntersectionObserver' in window) || reduce) {
        nums.forEach(setFinal);
        return;
      }
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (en.isIntersecting) { animate(en.target); io.unobserve(en.target); }
        });
      }, { threshold: 0.4 });
      nums.forEach(function (n) { io.observe(n); });
    }

    function sticky() {
      var bar = document.querySelector('.mfu-sticky');
      if (!bar) return;
      // Keep the sticky buy bar visible at all times — no matter whether the
      // main add-to-cart is on screen.
      bar.classList.add('show');
    }

    // Buy now -> open the Shiprocket (Fastrr) checkout directly for the button's
    // /cart/add form. Falls back to the cart permalink (also lands on checkout).
    window.mfuBuyNow = function (event) {
      if (event && event.preventDefault) event.preventDefault();
      var btn = (event && event.currentTarget) ||
                (event && event.target && event.target.closest && event.target.closest('button'));
      var form = btn && btn.closest ? btn.closest('form') : null;
      if (typeof window.shiprocketCheckoutBuyProductHandler === 'function') {
        try { window.shiprocketCheckoutBuyProductHandler(event); return; } catch (e) {}
      }
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput && idInput.value) { window.location.href = '/cart/' + idInput.value + ':1'; }
      }
    };


    function selectPack(pack) {
      var group = pack.closest('.packs');
      if (!group) return;
      group.querySelectorAll('[data-mfu-pack]').forEach(function (p) {
        p.classList.remove('sel'); p.setAttribute('aria-checked', 'false');
      });
      pack.classList.add('sel'); pack.setAttribute('aria-checked', 'true');
      var suffix = group.getAttribute('data-mfu-suffix') || '';
      var sel = document.getElementById('mfu-sticky-sel'),
          pr = document.getElementById('mfu-sticky-pr'),
          vid = document.getElementById('mfu-sticky-vid');
      if (sel) sel.textContent = (pack.getAttribute('data-name') || '') + suffix;
      if (pr) {
        var now = pack.getAttribute('data-now') || '',
            mrp = pack.getAttribute('data-mrp') || '',
            save = pack.getAttribute('data-save') || '';
        pr.innerHTML = now +
          (mrp ? ' <s>' + mrp + '</s>' : '') +
          (save ? ' <span class="save">' + save + '</span>' : '');
      }
      if (vid) vid.value = pack.getAttribute('data-variant-id') || '';
      // the hero button buys too, so its form needs the same variant
      var heroVid = document.getElementById('mfu-hero-vid');
      if (heroVid) heroVid.value = pack.getAttribute('data-variant-id') || '';
    }

    function openModal(sel) {
      var m = document.querySelector(sel);
      if (m) { m.classList.add('open'); document.documentElement.style.overflow = 'hidden'; }
    }
    function closeModal(m) { m.classList.remove('open'); document.documentElement.style.overflow = ''; }


    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var opener = e.target.closest('[data-mfu-modal]');
      if (opener) { e.preventDefault(); openModal(opener.getAttribute('data-mfu-modal')); return; }
      var closer = e.target.closest('[data-mfu-close], .mfu-modal-ov');
      if (closer) { var mm = closer.closest('.mfu-modal'); if (mm) { closeModal(mm); return; } }
      var pack = e.target.closest('[data-mfu-pack]');
      if (pack) selectPack(pack);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { var m = document.querySelector('.mfu-modal.open'); if (m) closeModal(m); }
      if (e.key === ' ' || e.key === 'Enter') {
        var pk = e.target.closest && e.target.closest('[data-mfu-pack]');
        if (pk && e.target === pk) { e.preventDefault(); selectPack(pk); }
      }
    });

    function addToCart(btn) {
      var id = btn.getAttribute('data-variant-id');
      if (!id || id === '') { return; }
      btn.setAttribute('aria-busy', 'true');
      var A = window.Alpine;
      var sections = [];
      try { if (A && A.store('xCartHelper')) sections = A.store('xCartHelper').getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          btn.removeAttribute('aria-busy');
          if (data.status) { console.error('Add to cart failed:', data.description); return; }
          if (A) {
            try {
              if (data.sections) A.store('xCartHelper').reRenderSections(data.sections);
              if (A.store('xCartNoti') && A.store('xCartNoti').enable) { A.store('xCartNoti').setItem(data); }
              else { A.store('xMiniCart').openCart(); }
              A.store('xCartHelper').currentItemCount = parseInt((document.querySelector('#cart-icon-bubble span') || {}).innerHTML || 0);
              document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            } catch (e) { window.location.href = '/cart'; }
          } else { window.location.href = '/cart'; }
        })
        .catch(function () { btn.removeAttribute('aria-busy'); window.location.href = '/cart'; });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-mfu-add]') : null;
      if (btn) { e.preventDefault(); addToCart(btn); }
    });

    // Gold-dust particle canvas over the hero image (paused off-screen; static for reduced-motion)
    function herodust() {
      var c = document.querySelector('.mfu-herodust');
      if (!c || !c.getContext) return;
      var x = c.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), W = 0, H = 0, parts = [], id = null, run = false;
      var N = (window.matchMedia && window.matchMedia('(max-width:767px)').matches) ? 24 : 50;
      var GOLD = ['#f4dd94', '#d6b165', '#c9a24b', '#8a6d2f'];
      function rs() { var r = c.getBoundingClientRect(); W = r.width; H = r.height; c.width = W * dpr; c.height = H * dpr; x.setTransform(dpr, 0, 0, dpr, 0, 0); }
      function spawn(p) { p = p || {}; p.x = Math.random() * W; p.y = H + Math.random() * H * 0.3; p.vy = -(0.12 + Math.random() * 0.4); p.vx = (Math.random() - 0.5) * 0.2; p.r = 0.5 + Math.random() * 1.5; p.life = 0; p.max = 240 + Math.random() * 260; p.c = GOLD[(Math.random() * GOLD.length) | 0]; p.tw = Math.random() * 6.28; return p; }
      function step() {
        x.clearRect(0, 0, W, H);
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i]; p.x += p.vx; p.y += p.vy; p.life++; p.tw += 0.05;
          var f = 1 - p.life / p.max;
          if (f <= 0 || p.y < -8) { spawn(p); continue; }
          x.globalAlpha = Math.max(0, Math.min(f, 0.8)) * (0.4 + 0.5 * Math.sin(p.tw));
          x.beginPath(); x.arc(p.x, p.y, p.r, 0, 6.2832); x.fillStyle = p.c; x.fill();
        }
        x.globalAlpha = 1; id = requestAnimationFrame(step);
      }
      function stat() { rs(); for (var i = 0; i < N; i++) { x.globalAlpha = 0.15 + Math.random() * 0.4; x.beginPath(); x.arc(Math.random() * W, Math.random() * H, 0.5 + Math.random() * 1.4, 0, 6.2832); x.fillStyle = GOLD[(Math.random() * GOLD.length) | 0]; x.fill(); } x.globalAlpha = 1; }
      if (reduce) { stat(); window.addEventListener('resize', stat); return; }
      rs();
      for (var i = 0; i < N; i++) { var q = spawn({}); q.life = Math.random() * q.max; parts.push(q); }
      window.addEventListener('resize', rs);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          if (es[0].isIntersecting && !run) { run = true; id = requestAnimationFrame(step); }
          else if (!es[0].isIntersecting && run) { run = false; cancelAnimationFrame(id); }
        }, { threshold: 0 }).observe(c);
      } else { run = true; id = requestAnimationFrame(step); }
    }

    function init() { reveal(); counters(); sticky(); herodust(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
}